export default __webpack_public_path__ + "static/media/no_ticket_icon.1ee285d7.svg";